(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.AdminHeaderController = (function(superClass) {
    extend(AdminHeaderController, superClass);

    function AdminHeaderController(scope, state, http, window, session) {
      this.scope = scope;
      this.state = state;
      this.http = http;
      this.window = window;
      this.session = session;
      this.stopMasquerading = bind(this.stopMasquerading, this);
      this.masquerade = bind(this.masquerade, this);
      this.close = bind(this.close, this);
      this.open = bind(this.open, this);
      this.toggle = bind(this.toggle, this);
      this.masqueradePipe = bind(this.masqueradePipe, this);
      this.handleKeyup = bind(this.handleKeyup, this);
      this.scope.isOpen = false;
      this.scope.barVisible = true;
      this.scope.displayedCollection = [];
      this.scope.users = [];
      this.scope.selectedUser = null;
      this.scope.toggle = this.toggle;
      this.scope.close = this.close;
      this.scope.masquerade = this.masquerade;
      this.scope.stopMasquerading = this.stopMasquerading;
      this.scope.masqueradePipe = this.masqueradePipe;
      this.scope.searchMasqueradeUsers = this.searchMasqueradeUsers;
      this.scope.handleKeyup = this.handleKeyup;
      this.scope.session = this.session;
      this.scope.$on('keypress:96', (function(_this) {
        return function(event, keypressEvent) {
          keypressEvent.preventDefault();
          _this.scope.barVisible = true;
          return _this.toggle();
        };
      })(this));
      this.scope.$on('keypress:126', (function(_this) {
        return function(event, keypressEvent) {
          keypressEvent.preventDefault();
          _this.scope.barVisible = !_this.scope.barVisible;
          if (!_this.scope.barVisible) {
            return _this.close();
          }
        };
      })(this));
      this.scope.$on('keypress:13', (function(_this) {
        return function(event, keypressEvent) {
          if (!_this.scope.isOpen) {
            return;
          }
          return _this.masquerade(_this.scope.selectedUser);
        };
      })(this));
    }

    AdminHeaderController.prototype.handleKeyup = function(event) {
      var index;
      switch (event.which) {
        case 38:
          index = this.scope.displayedCollection.indexOf(this.scope.selectedUser);
          if (index > 0) {
            return this.scope.selectedUser = this.scope.displayedCollection[index - 1];
          }
          break;
        case 40:
          index = this.scope.displayedCollection.indexOf(this.scope.selectedUser);
          if (index < this.scope.displayedCollection.length - 1) {
            return this.scope.selectedUser = this.scope.displayedCollection[index + 1];
          }
      }
    };

    AdminHeaderController.prototype.masqueradePipe = function(tableState) {
      var ref, ref1;
      return this.http.post('backend/session-mgmt/get-masquerade-users', {
        searchText: ((ref = tableState.search) != null ? (ref1 = ref.predicateObject) != null ? ref1.$ : void 0 : void 0) || '',
        start: tableState.pagination.start,
        number: tableState.pagination.number,
        app: this.state.$current.name.split('.')[0]
      }).then((function(_this) {
        return function(response) {
          _this.scope.displayedCollection = response.data.users;
          if (_this.scope.displayedCollection.length) {
            _this.scope.selectedUser = _this.scope.displayedCollection[0];
          }
          if (response.data.total === 0) {
            return tableState.pagination.numberOfPages = 0;
          } else {
            return tableState.pagination.numberOfPages = response.data.total / tableState.pagination.number;
          }
        };
      })(this));
    };

    AdminHeaderController.prototype.toggle = function() {
      return this.scope.isOpen = !this.scope.isOpen;
    };

    AdminHeaderController.prototype.open = function() {
      if (!this.scope.isOpen) {
        return this.toggle();
      }
    };

    AdminHeaderController.prototype.close = function() {
      if (this.scope.isOpen) {
        return this.toggle();
      }
    };

    AdminHeaderController.prototype.masquerade = function(user) {
      if (this.state.$current.name === 'grower.declarations.saifsa') {
        console.error('Go back to the declarations page before masquerading');
        return;
      }
      return this.http.post((Config.get('api_url')) + "/masquerade-token", {
        userId: user.id
      }).then((function(_this) {
        return function(response) {
          var token;
          token = response.data.token;
          _this.session.set('Authorization', "Bearer " + token);
          _this.session.set('SafeLink', "Bearer " + token);
          _this.session.set('SelectedCompany-grower', user.company);
          _this.session.set('SelectedCompany-portal', user.company);
          return _this.window.location.reload();
        };
      })(this));
    };

    AdminHeaderController.prototype.stopMasquerading = function() {
      var app;
      if (this.state.$current.name === 'grower.declarations.saifsa') {
        console.error('Go back to the declarations page before masquerading');
        return;
      }
      app = this.state.$current.name.split('.')[0];
      this.session.set('Authorization', this.session.get('OriginalUser'));
      this.session.set('SafeLink', this.session.get('OriginalUser'));
      this.session.set('SelectedCompany-grower', 'Myfarms');
      this.session.set('SelectedCompany-portal', 'Myfarms');
      return this.window.location.reload();
    };

    return AdminHeaderController;

  })(Controller);

}).call(this);
